export default "__VITE_ASSET__Drm9AwEU__"